import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { ApiEndpointService } from "@webapp/core/app-config/services/api-endpoint.service";
import { v4 as uuidv4 } from "uuid";
import { TracingService } from "@webapp/core/tracing/services/tracing.service";
import { ITrackDataRequestParams } from "@webapp/core/tracing/models/tracing.models";

@Injectable({
  providedIn: "root",
})
export class TrackDataInterceptor implements HttpInterceptor {
  constructor(private apiEndpointService: ApiEndpointService, private tracingService: TracingService) {}
  intercept(request: HttpRequest<object>, next: HttpHandler): Observable<HttpEvent<object>> {
    request = this.attachHeaders(request);

    return next.handle(request).pipe(
      catchError((response: HttpErrorResponse) => {
        return throwError(response);
      })
    );
  }

  private attachHeaders(request: HttpRequest<object>): HttpRequest<object> {
    if (this.apiEndpointService.isApiRequest(request.url)) {
      const screen = this.tracingService.getScreen();
      const stateName = screen ? screen.screenName : "<unknown>";

      let map = {
        "gtmhub-application-name": "webapp",
        "gtmhub-path": stateName,
      };

      if (window.amplitude && window.amplitude.getSessionId) {
        map["gtmhub-session-id"] = window.amplitude.getSessionId();
      }

      const requestParams = request.params as ITrackDataRequestParams;

      if (requestParams && requestParams.gtmhubAdditionalParams) {
        map = {
          ...map,
          ...requestParams.gtmhubAdditionalParams,
        };
        delete requestParams.gtmhubAdditionalParams;
      }

      const params = [];
      Object.keys(map).forEach((key) => {
        const value = map[key];
        const param = [key, value].join("=");
        params.push(param);
      });

      return request.clone({
        setHeaders: {
          "gtmhub-additional-params": params.join(","),
          "transaction-id": uuidv4(),
        },
      });
    }

    return request.clone();
  }
}
